module.exports = __webpack_public_path__ + "media/application/images/ui/icon-pinterest-1438a00f6521f737e8f3c1e6eb7340ac.png";